export default "__VITE_ASSET__h380YYj727PmRFA3S5$RuQ__"